import { Multirange, Range } from '@attain-apps/range'

import * as common from '../../../../../common'
import * as models from '../../../../models'
import type * as expressionNode from '../../node'
import { getAllHelpers, getHelper } from '../all'
import { DmsDate, DmsMultiRange, DmsRange } from '../definitions'
import { Instance } from '../instance'

/**
 * Creates an {@link expressionNode.ForValue} from the given {@link Instance}
 */
export function from<T>(
  instance: Instance<T>,
  context: expressionNode.Context,
): expressionNode.ForValue<T> {
  return getHelper(instance).createNode(instance, context)
}

// Adds special logic for casting instances
common.value.Raw.cast.registerSpecialHandler('start', (originalVal, type) => {
  if (!Instance.isInstance(originalVal)) {
    // We only handle instances here
    return undefined
  }
  // Simply calls the default casting logic, but with the rendered value of this
  // instance
  // instance Range => DmsRange
  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    continueWith: from<any>(originalVal, {
      queryNodeId: 'n/a',
      schema: new models.Schema(),
      siblingExpressionNodes: {},
      subqueryNodes: {},
      variables: {},
    }).value,
  }
})

common.value.Raw.cast.registerSpecialHandler('end', originalVal => {
  for (const helper of getAllHelpers()) {
    if (helper.runtimeTypeChecker(originalVal)) {
      // Already a DMS type, no conversion needed
      return { return: originalVal as common.value.Raw }
    }
  }
  if (originalVal instanceof Date) {
    return { return: new DmsDate(originalVal) }
  }
  if (originalVal instanceof Range) {
    return { return: new DmsRange(originalVal) }
  }
  if (originalVal instanceof Multirange) {
    return { return: new DmsMultiRange(originalVal) }
  }

  return undefined
})
